<template>
  <sub-page title="我的培训">
    <div class="training-page">
      <!-- 功能图标网格 -->
      <div class="grid-wrap">
        <div class="grid-item" v-for="(item, idx) in gridList" :key="idx" @click="handleClick(item)">
          <div class="grid-icon-wrap" :style="{ background: item.bg }">
            <img :src="item.icon" class="grid-icon" :alt="item.title" />
          </div>
          <span class="grid-title">{{ item.title }}</span>
        </div>
      </div>

      <!-- 最近学习 -->
      <div class="section-title">最近学习</div>
      <div class="learn-list">
        <div class="learn-card" v-for="(item, idx) in learnList" :key="idx">
          <div class="learn-name">{{ item.name }}</div>
          <div class="learn-progress">
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: item.progress + '%' }"></div>
            </div>
            <span class="progress-text">{{ item.progress }}%</span>
          </div>
        </div>
        <div v-if="!learnList.length" class="empty-state">
          <img :src="emptyImg" class="empty-img" alt="empty" />
          <div class="empty-text">暂无学习记录</div>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'MyTraining',
  components: { SubPage },
  data() {
    return {
      emptyImg: require('@/assets/icons/empty.png'),
      gridList: [
        { title: '培训机构查询', icon: require('@/assets/icons/svc-org-query.png'), bg: 'linear-gradient(135deg, #EBF4FE, #D6E8FD)' },
        { title: '培训报名', icon: require('@/assets/icons/svc-train-cert.png'), bg: 'linear-gradient(135deg, #E8FAF1, #D2F5E4)' },
        { title: '我的课程', icon: require('@/assets/icons/svc-record.png'), bg: 'linear-gradient(135deg, #FFF6E8, #FFEBCC)' },
        { title: '培训补贴', icon: require('@/assets/icons/svc-train-subsidy.png'), bg: 'linear-gradient(135deg, #FFF0F0, #FFE0E0)' },
        { title: '培训评价', icon: require('@/assets/icons/svc-train-eval.png'), bg: 'linear-gradient(135deg, #F5EBFE, #EBD9FD)' },
        { title: '证书查询', icon: require('@/assets/icons/svc-cert-query.png'), bg: 'linear-gradient(135deg, #E8F9FB, #D1F2F7)' }
      ],
      learnList: [
        { name: '职业技能提升培训课程一', progress: 65 },
        { name: '安全生产教育培训', progress: 30 }
      ]
    }
  },
  methods: {
    handleClick(item) {
      console.log('Clicked:', item.title)
    }
  }
}
</script>

<style scoped>
.training-page {
  background: #F3F8FB;
  min-height: 100%;
  padding: calc(24 * var(--w));
}
.grid-wrap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: calc(20 * var(--w));
  background: #fff;
  border-radius: calc(16 * var(--w));
  padding: calc(32 * var(--w)) calc(24 * var(--w));
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(0, 0, 0, 0.06);
}
.grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(16 * var(--w));
  cursor: pointer;
  transition: transform 0.2s;
}
.grid-item:active {
  transform: scale(0.96);
}
.grid-icon-wrap {
  width: calc(96 * var(--w));
  height: calc(96 * var(--w));
  border-radius: calc(20 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
}
.grid-icon {
  width: calc(60 * var(--w));
  height: calc(60 * var(--w));
  object-fit: contain;
}
.grid-title {
  font-size: calc(28 * var(--w));
  color: #323233;
  text-align: center;
}
.section-title {
  margin-top: calc(40 * var(--w));
  margin-bottom: calc(20 * var(--w));
  font-size: calc(32 * var(--w));
  font-weight: 600;
  color: #323233;
  display: flex;
  align-items: center;
  gap: calc(12 * var(--w));
}
.section-title::before {
  content: '';
  width: calc(8 * var(--w));
  height: calc(32 * var(--w));
  border-radius: calc(4 * var(--w));
  background: linear-gradient(180deg, #2E8CF6, #5EA9FA);
}
.learn-list {
  display: flex;
  flex-direction: column;
  gap: calc(20 * var(--w));
}
.learn-card {
  background: #fff;
  border-radius: calc(16 * var(--w));
  padding: calc(28 * var(--w)) calc(32 * var(--w));
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(0, 0, 0, 0.06);
}
.learn-name {
  font-size: calc(30 * var(--w));
  color: #323233;
  font-weight: 500;
  margin-bottom: calc(20 * var(--w));
}
.learn-progress {
  display: flex;
  align-items: center;
  gap: calc(16 * var(--w));
}
.progress-bar {
  flex: 1;
  height: calc(14 * var(--w));
  background: #F0F2F5;
  border-radius: calc(7 * var(--w));
  overflow: hidden;
}
.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #2E8CF6, #5EA9FA);
  border-radius: calc(7 * var(--w));
  transition: width 0.3s;
}
.progress-text {
  font-size: calc(28 * var(--w));
  color: #2E8CF6;
  font-weight: 500;
  width: calc(64 * var(--w));
  text-align: right;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: calc(100 * var(--w));
}
.empty-img {
  width: calc(200 * var(--w));
  height: calc(200 * var(--w));
  object-fit: contain;
}
.empty-text {
  margin-top: calc(24 * var(--w));
  font-size: calc(30 * var(--w));
  color: #969799;
}
</style>



// WEBPACK FOOTER //
// src/pages/MyTraining.vue